import gsap from 'gsap';

export default class Faq {
  constructor() {
      // Faq
      this.initAccordions();
      this.accordionsManagement();
  }

  initAccordions() {
    const accordions = document.querySelectorAll('.accordion-container .accordion-wrapper .accordion');
    if (accordions.length > 0) {
      accordions.forEach((accordion) => {
        accordion.style.height = '0px';
        gsap.set(accordion, { height: 0 });
      });
    }
  }

  accordionsManagement() {
    const accordions = document.querySelectorAll('.accordion-container .accordion-wrapper');
    if (accordions.length > 0) {
      accordions.forEach((accordion) => {
        accordion.querySelector('h2').addEventListener('click', () => {
          accordion.classList.toggle('open');

          if (accordion.classList.contains('open')) {
            gsap.set(accordion.querySelector('.accordion'), { height: 'auto' });
            gsap.from(
              accordion.querySelector('.accordion'),
              {
                duration: 1,
                height: 0,
                ease: 'power4.out'
              }
            );
          } else {
            gsap.to(
              accordion.querySelector('.accordion'),
              {
                duration: 1,
                height: 0,
                ease: 'power4.out'
              }
            );
          }
        });
      });
    }
  }
}